import React from 'react';

const BaseReplay3DLayout = ({ res }) => (
  <div id="replay3dBaseApp">
    <aside className="panel">
      <div className="panel-header">
        <h1>{res.REPLAY_3D_TITULO}</h1>
        <button id="panelToggleBtn" className="panel-toggle" type="button" aria-pressed="false" title={res.OCULTAR_MENU_LATERAL}>{res.OCULTAR_MENU}</button>
      </div>
      <p className="subtitle">{res.DADOS_TRABALHO_ATUAL}</p>

      <div className="field">
        <label htmlFor="aircraftSelect">{res.AERONAVE_CATALOGO}</label>
        <select id="aircraftSelect" />
      </div>

      <div className="field replay3d-official-hidden">
        <label htmlFor="modelUrl">{res.URL_MODELO_GLB_MANUAL}</label>
        <input id="modelUrl" type="text" defaultValue="./assets/replay_3d/models/emb-200/aeronave.glb" />
      </div>

      <div className="field replay3d-official-hidden">
        <label htmlFor="kmzFile">{res.ARQUIVO_VOO_KMZ_KML}</label>
        <input id="kmzFile" type="file" accept=".kmz,.kml" />
      </div>

      <div className="controls playback-controls">
        <button id="loadBtn" className="replay3d-official-hidden" type="button">{res.CARREGAR_VOO}</button>
        <button id="playBtn" disabled>{res.INICIAR}</button>
        <button id="pauseBtn" disabled>{res.PAUSAR}</button>
        <button id="repeatBtn" type="button" aria-pressed="false" disabled>{res.REPETIR}</button>
      </div>

      <div className="field slider-wrap">
        <label htmlFor="timelineSlider">{res.LINHA_TEMPO}</label>
        <input id="timelineSlider" type="range" min="0" max="1000" defaultValue="0" disabled />
      </div>

      <div className="field">
        <label htmlFor="speedSelect">{res.VELOCIDADE}</label>
        <select id="speedSelect" defaultValue="1" disabled>
          <option value="1">1x</option>
          <option value="2.5">2,5x</option>
          <option value="5">5x</option>
          <option value="10">10x</option>
          <option value="15">15x</option>
          <option value="20">20x</option>
        </select>
      </div>

      <div className="field">
        <label>{res.NAVEGACAO_MAPA}</label>
        <div className="controls map-controls">
          <button id="zoomInBtn" type="button">{res.ZOOM_MAIS}</button>
          <button id="zoomOutBtn" type="button">{res.ZOOM_MENOS}</button>
          <button id="centerPlaneBtn" type="button" disabled>{res.CENTRALIZAR}</button>
        </div>
      </div>

      <div className="field">
        <label>{res.TRACADO_VOO}</label>
        <div className="controls one-col">
          <button id="pathToggleBtn" type="button" disabled>{res.OCULTAR_TRACADO}</button>
        </div>
      </div>

      <div className="field">
        <label>{res.ANALISE_APLICACAO}</label>
        <div className="controls one-col">
          <button id="qualitySprayToggleBtn" type="button" aria-pressed="false" disabled>{res.QUALIDADE_DESATIVADA}</button>
        </div>
        <select id="qualitySprayParameterSelect" className="quality-spray-select" defaultValue="aplicacao" disabled>
          <option value="aplicacao">{res.APLICACAO}</option>
          <option value="altura">{res.ALTURA}</option>
          <option value="fluxo">{res.FLUXO}</option>
          <option value="velocidade">{res.VELOCIDADE}</option>
          <option value="velocidadeVento">{res.VELOCIDADE_VENTO}</option>
          <option value="direcaoVento">{res.DIRECAO_VENTO}</option>
          <option value="deltaT">{res.DELTA_T}</option>
          <option value="temperatura">{res.TEMPERATURA_}</option>
          <option value="humidade">{res.UMIDADE_}</option>
        </select>
      </div>

      <div className="field">
        <label>{res.MARCADOR_AERONAVE}</label>
        <div className="controls one-col">
          <button id="aircraftMarkerToggleBtn" type="button" disabled>{res.OCULTAR_MARCADOR}</button>
        </div>
      </div>

      <div className="field">
        <label>{res.FOCO_AREA_APLICACAO}</label>
        <div className="controls one-col">
          <button id="transitFocusToggleBtn" type="button" disabled>{res.FOCO_4KM_OFF}</button>
        </div>
      </div>

      <div className="field">
        <label>{res.MEDICAO_INICIO_PRIMEIRA_APLICACAO}</label>
        <div className="controls one-col">
          <button id="measureToggleBtn" type="button" disabled>{res.MOSTRAR_MEDICAO}</button>
        </div>
      </div>

      <div className="field">
        <label>{res.MEDICAO_BALAO_CORRENTE}</label>
        <div className="controls one-col">
          <button id="balloonMeasureToggleBtn" type="button" disabled>{res.MOSTRAR_MEDICAO_BALAO}</button>
        </div>
      </div>

      <div className="field">
        <label htmlFor="viewModeSelect">{res.VISAO_AERONAVE}</label>
        <select id="viewModeSelect" defaultValue="follow" disabled>
          <option value="follow">{res.SEGUIR}</option>
          <option value="chase">{res.PERSEGUIR}</option>
          <option value="orbit">{res.ORBITA_MANUAL}</option>
          <option value="top">{res.TOPO}</option>
          <option value="free">{res.LIVRE}</option>
        </select>
      </div>

      <div className="field slider-wrap">
        <label htmlFor="cameraHeadingOffset">{res.ANGULO_LATERAL}: <span id="cameraHeadingOffsetValue">0°</span></label>
        <input id="cameraHeadingOffset" type="range" min="-180" max="180" step="1" defaultValue="0" disabled />
      </div>

      <div className="field slider-wrap">
        <label htmlFor="cameraPitch">{res.ANGULO_VERTICAL}: <span id="cameraPitchValue">-20°</span></label>
        <input id="cameraPitch" type="range" min="-85" max="-5" step="1" defaultValue="-20" disabled />
      </div>

      <div className="field slider-wrap">
        <label htmlFor="cameraRange">{res.DISTANCIA_CAMERA}: <span id="cameraRangeValue">240 m</span></label>
        <input id="cameraRange" type="range" min="80" max="3000" step="10" defaultValue="240" disabled />
      </div>

      <div className="field slider-wrap">
        <label htmlFor="modelScale">{res.ESCALA_AVIAO}: <span id="modelScaleValue">2.4x</span></label>
        <input id="modelScale" type="range" min="0.05" max="8" step="0.05" defaultValue="2.4" disabled />
      </div>

      <div className="field slider-wrap">
        <label htmlFor="sprayFootprintOpacity">{res.OPACIDADE_FAIXA}: <span id="sprayFootprintOpacityValue">80%</span></label>
        <input id="sprayFootprintOpacity" type="range" min="0" max="100" step="1" defaultValue="80" disabled />
      </div>

      <div className="status" id="statusBox">{res.CARREGANDO_DADOS_TRABALHO_ATUAL}</div>

      <div className="legend">
        <div><span className="dot spray" /> {res.PULVERIZANDO}</div>
        <div><span className="dot nospray" /> {res.SEM_PULVERIZACAO}</div>
      </div>
    </aside>

    <button id="panelRestoreBtn" className="panel-restore-btn" type="button" aria-pressed="true" title={res.MOSTRAR_MENU_LATERAL}>{res.MOSTRAR_MENU}</button>

    <div id="compactControls" className="compact-controls" aria-hidden="true">
      <div className="compact-row compact-playback">
        <button id="miniPlayBtn" type="button" disabled>{res.INICIAR}</button>
        <button id="miniPauseBtn" type="button" disabled>{res.PAUSAR}</button>
        <button id="miniRepeatBtn" type="button" aria-pressed="false" disabled>{res.REPETIR}</button>
      </div>

      <div className="compact-row compact-toggles">
        <button id="miniPathToggleBtn" type="button" disabled>{res.MOSTRAR_TRACADO}</button>
        <button id="miniAircraftMarkerToggleBtn" type="button" disabled>{res.MOSTRAR_MARCADOR}</button>
        <button id="miniTransitFocusToggleBtn" type="button" disabled>{res.FOCO_4KM_OFF}</button>
      </div>

      <div className="compact-row compact-timeline">
        <input id="miniTimelineSlider" type="range" min="0" max="1000" defaultValue="0" disabled />
      </div>

      <div className="compact-row compact-selects">
        <select id="miniSpeedSelect" defaultValue="1" disabled>
          <option value="1">1x</option>
          <option value="2.5">2,5x</option>
          <option value="5">5x</option>
          <option value="10">10x</option>
          <option value="15">15x</option>
          <option value="20">20x</option>
        </select>

        <select id="miniViewModeSelect" defaultValue="follow" disabled>
          <option value="follow">{res.SEGUIR}</option>
          <option value="chase">{res.PERSEGUIR}</option>
          <option value="orbit">{res.ORBITA}</option>
          <option value="top">{res.TOPO}</option>
          <option value="free">{res.LIVRE}</option>
        </select>
      </div>
    </div>

    <div id="telemetryBoard" className="telemetry-board" aria-live="polite">
      <h2>{res.PLACAR_OPERACAO}</h2>
      <div className="telemetry-grid">
        <div className="telemetry-row"><span>{res.HECTARES_APLICADOS}</span><strong id="telemetryHectaresApplied">--</strong></div>
        <div className="telemetry-row"><span>{res.VELOCIDADE_AERONAVE}</span><strong id="telemetryAircraftSpeed">--</strong></div>
        <div className="telemetry-row"><span>{res.FLUXO_INSTANTANEO}</span><strong id="telemetryFlowInstant">--</strong></div>
        <div className="telemetry-row"><span>{res.FLUXO_MEDIO}</span><strong id="telemetryFlowAverage">--</strong></div>
        <div className="telemetry-row"><span>{res.ALTURA}</span><strong id="telemetryAltitude">--</strong></div>
        <div className="telemetry-row"><span>{res.ALTURA_MEDIA}</span><strong id="telemetryAltitudeAverage">--</strong></div>
        <div className="telemetry-row"><span>{res.RENDIMENTO_HA_H}</span><strong id="telemetryYieldHaPerHour">--</strong></div>
        <div className="telemetry-row"><span>{res.TEMPO_APLICACAO}</span><strong id="telemetryTimeSpray">--</strong></div>
        <div className="telemetry-row"><span>{res.TEMPO_BALAO}</span><strong id="telemetryTimeBalloon">--</strong></div>
        <div className="telemetry-row"><span>{res.TEMPO_TRANSLADO}</span><strong id="telemetryTimeTransit">--</strong></div>
        <div className="telemetry-row"><span>{res.TEMPO_REABASTECIMENTO}</span><strong id="telemetryTimeRefuel">--</strong></div>
      </div>
    </div>

    <main id="cesiumContainer" />
  </div>
);

export default BaseReplay3DLayout;
